import {
  ILabel,
  ILabelDetailed,
  LabelProcessingTypeEnum,
} from 'Modules/Communication/shared/models/Labels'

export interface SystemState {
  communication: {
    labels: {
      data: ILabel[]
      error: any
      loading: boolean
      processing: LabelProcessingTypeEnum | null
      processingError: string | null
      details: ILabelDetailed | null
    }
  }
}

export const getInboxLabels = (state: SystemState) => state.communication.labels
